import { AppConfig } from "AppConfig";
import { getRequestHeaders } from "msal/MsalAuthProvider";
import { createLog } from "_data/services/extract/service";

export const getUsersRequest = (callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/admin/user`;

  fetch(url, {
    method: "GET",
    headers: getRequestHeaders(),
  })
    .then((response) => response.json())
    .then((response) => {
      callback(true, response);
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Get list of users : ${error}`);
    });
};

export const getActivitiesRequest = (callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/admin/activity`;

  fetch(url, {
    method: "GET",
    headers: getRequestHeaders(),
  })
    .then((response) => response.json())
    .then((response) => {
      callback(true, response);
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Get list of activities : ${error}`);
    });
};

export const getExportExcelRequest = (callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/admin/excel`;

  fetch(url, {
    method: "GET",
    headers: getRequestHeaders(),
  })
    .then(async (response) => {
      const disposition = response.headers.get("Content-Disposition") || "";
      const match = /filename="?(.+?)"?($|;)/.exec(disposition);
      const fileName = match
        ? match[1]
        : "NemEkstrakt.User.Activity.Report.xlsx";
      const blob = await response.blob();
      return { blob, fileName };
    })
    .then(({ blob, fileName }) => {
      callback(true, blob, fileName);
    })
    .catch((error) => {
      callback(false, null, null);
      createLog("Error", `Get excel file of activities and users : ${error}`);
    });
};
